import React, { Component } from "react";
import Status from "./Status";
import List from "./List";
import Filters from "../filters";
import examsService from "../../services/ExamsService";
import {
  FETCH_INTERVAL, PRODUCTION_UNIT_ALIAS, PRODUCTION_UNIT_NAMES,
} from "../../constants";
import { withRouter } from "react-router";
import ExamsService from "../../services/ExamsService";
import { addPaddingInMap, isAlphanumericOrderId, searchIndex} from "../../util/utils";
import History from "../history";
import LoadDNA from "./../LoadDNA";
import userService from "../../services/UserService";
import { sendEvent } from "../../util/utils";
import moment from "moment";
import {STAGE_SHORT} from '../../constants';

const ORDER_DATE = {
  "Mais recentes": "ASC",
  "Mais antigos": "DESC",
  "Mais urgentes": "DESC",
};
class Exams extends Component {
  constructor(props) {
    super(props);

    this.state = {
      exams: null,
      listEnd: 1,
      listOrder: "Mais recentes",
      listPage: 1,
      lastId: null,
      hasFilter: false,
      hasFilterSearch: false,
      renderFilterScreen: false,
      paginationIds: [],
      filters: {},
      filtersSearch: {},
      searchValue: "",
      renderHistory: false,
      examHistory: null,
      loading: false,
      loadingExams: false,
      orderBy: null,
      isShowingHistory: false,
    };

    this.recurrentGetReference = null;
    this.inputSearchRef = React.createRef();
  }

  async componentDidMount() {
    if (userService.getUserType() !== "L2L"){
      this.setState({ loading: true });
      await this.startGettingExamsData(null, this.getQuery(this.state.filters));
      this.setState({ loading: false });
      this.updateListEnd();
    }
    this.startListeningEvents();
  }

  componentWillUnmount() {
    this.stopGettingData();
    this.stopListeningEvents();
  }

  startListeningEvents() {
    window.addEventListener("apply-production-unit-filter", this.applyStageProductionUnitFilterOnFilterOrSearch.bind(this));
    window.addEventListener("apply-stage-production-unit-filter", this.applyStageProductionUnitFilterOnFilterOrSearch.bind(this));
  }

  stopListeningEvents() {
    window.removeEventListener("apply-production-unit-filter", this.applyStageProductionUnitFilterOnFilterOrSearch.bind(this));
    window.removeEventListener("apply-stage-production-unit-filter", this.applyStageProductionUnitFilterOnFilterOrSearch.bind(this));
  }

  stopGettingData() {
    examsService.stopGettingDataFrom("get");
  }

  async startGettingExamsData(
    orderBy = {},
    filterBy = {},
    page = 1,
    lastId = null
  ) {
    examsService.stopGettingDataFrom("get");
    this.setState({loadingExams: true});
    await examsService.startGettingDataFrom(
      "get",
      {
        orderBy: orderBy,
        filterBy: filterBy,
        limit: 20,
        page: page,
        lastId: lastId,
      },
      this.updateExams.bind(this),
      FETCH_INTERVAL
    );
  }

  updateExams(exams) {
    if (exams && exams.total && !this.state.renderHistory) {
      let lastId = exams.lastId;
      let Ids = [];
      if (this.state.paginationIds.length === 0) {
        Ids.push(lastId);
        this.setState({ paginationIds: Ids });
      }
      this.setState({ exams, lastId, loadingExams: false});
      sendEvent("draw-exams", exams);
    } else if(!this.state.renderHistory && (!this.state.hasFilter && (!this.state.searchValue || this.state.searchValue===""))){
      this.setState({ exams: null, loadingExams: false });
      sendEvent("draw-exams", exams);
    } else if((!exams || !exams.total )&& (this.state.hasFilter || this.state.searchValue)){
      this.setState({ exams: null, loadingExams: false });
      sendEvent("draw-exams", "no-results");
    }
  }

  async applyStageProductionUnitFilterOnFilterOrSearch(event){

    let productionUnit = event && event.detail && event.detail.productionUnit;
    let stage = event && event.detail && event.detail.stage;
    let isValidProductionUnit = productionUnit && PRODUCTION_UNIT_NAMES[productionUnit];
    let filters = this.state.filtersSearch;
    if(this.state.searchValue){
      stage && (filters["EventStage"] = [stage]);
      isValidProductionUnit && (filters["ProductionUnitName"] = productionUnit);
      this.setState({filtersSearch: filters});
      this.applyStageProductionUnitFilterOnSearch(productionUnit, stage);
    } else{
      this.applyStageProductionUnitFilter(productionUnit, stage);
    }
  }

  async applyStageProductionUnitFilterOnSearch(productionUnit, stage, orderBy = "orderDate", order = "ASC") {
    let userType = userService.getUserType();
    let searchValue = this.state.searchValue;
    let isOrderId =  searchValue.length === 10 && !isNaN(searchValue);
    let filters = [];

    if (searchValue) {
      if(isOrderId){
        filters.push({ OrderId: searchValue });
        productionUnit && filters.push({ ProductionUnitName: productionUnit });
        stage && filters.push({ EventStage: [stage] });

        await this.startGettingExamsData({ [orderBy]: order }, filters);
      } else {
        if (userType === "PSC") {
          filters.push({ ExamDescription: [searchValue] });
          productionUnit && filters.push({ ProductionUnitName: productionUnit });
          stage && filters.push({ EventStage: [stage] });

          await this.startGettingExamsData({ [orderBy]: order }, filters);
        } else {
          filters.push({ PatientName: searchValue });
          filters.push({ExamDescription: [searchValue]});
          productionUnit && filters.push({ ProductionUnitName: productionUnit });
          stage && filters.push({ EventStage: [stage] });

          await this.startGettingExamsData({ [orderBy]: order }, filters);
        }
      }
      this.setState({hasFilterSearch: true})
    }
    this.updateListEnd()
  }

  async applyStageProductionUnitFilter(productionUnit, stage){
    try { 

      let isValidProductionUnit = productionUnit && PRODUCTION_UNIT_NAMES[productionUnit];

      if(isValidProductionUnit || stage){
        let filters = this.state.filters;

        !this.state.filters && this.setState({filters: {}});
        isValidProductionUnit && (filters["ProductionUnitName"] = productionUnit);
        stage && (this.state.filters["EventStage"] = [stage]);
        this.setState({filters: filters});

        this.state.hasFilter = true;
        this.state.paginationIds = [];
        this.state.lastId = null;
        this.state.searchValue = '';
        this.state.listOrder = 'Mais recentes';
        await this.startGettingExamsData({}, this.getQuery(filters));
        this.state.listEnd = this.hasExamList() ? this.state.exams.exams.length: 0;
        this.setState(this.state);
      }
    } catch (error) {
      console.error("Error trying to apply stage production unit filter: ", error.message);
    }
  }

  closeDropDown() {
    let menu = document.querySelector(".dropdown-menu");
    if (menu.classList.contains("user-type-menu")) {
      menu.classList.remove("user-type-menu");
    }
  }

  openDropDown() {
    let menu = document.querySelector("#dropdown-menu-filter");
    if (!menu.classList.contains("user-type-menu")) {
      menu.classList.add("user-type-menu");
    }
  }

  async toggleOrderby(id) {
    let menu = document.getElementById("dropdown-menu-filter");
    let options = menu.getElementsByClassName("dropdown-item");

    for (var c = 0; c < options.length; c++) {
      if (options[c].classList.contains("active")) {
        options[c].classList.remove("active");
      }
    }

    let active = document.getElementById(id);

    active.classList.add("active");

    document
      .getElementById("dropdown-menu-filter")
      .classList.remove("user-type-menu");

    if (id === "antigos") {
      this.updateSearch("orderDate", "ASC");
      this.setState({
        listOrder: "Mais " + id,
        paginationIds: [],
        lastId: null,
      });
    } else if (id === "recentes") {
      this.updateSearch("orderDate", "DESC");
      this.setState({
        listOrder: "Mais " + id,
        paginationIds: [],
        lastId: null,
      });
    } else if (id === "urgentes") {
      this.updateSearch("urgency", "DESC");
      this.setState({
        listOrder: "Mais " + id,
        paginationIds: [],
        lastId: null,
      });
    } else {
      console.error("Error when trying to apply orderby: invalid option.");
    }
  }

  async clearAllFilters() {
    this.state.filters = {};
    this.state.filtersSearch = {};
    this.state.hasFilter = false;
    this.state.hasFilterSearch = false;
    this.state.paginationIds = [];
    this.state.lastId = null;
    this.state.listEnd = 1;
    this.state.listPage = 1;
    this.state.listOrder = 'Mais recentes';
    this.setState(this.state);
    
    if (userService.getUserType() === "L2L") {
      if(this.state.searchValue === ""){
        this.stopGettingData();
        this.updateExams(null);
      }else{
        this.updateSearch();
      }
    } else {
      if (this.state.listOrder == "Mais recentes") {
        await this.startGettingExamsData({ orderDate: "ASC" });
      } else if (this.state.listOrder == "Mais antigos") {
        await this.startGettingExamsData({ orderDate: "DESC" });
      } else if (this.state.listOrder == "Mais urgentes") {
        await this.startGettingExamsData({ urgency: "DESC" });
      }
    }
    this.updateListEnd();
  }

  async addStatusFilter(filterName) {
    if (!this.state.filters["EventStage"]) {
      this.state.filters["EventStage"] = [];
    }
    this.state.filters["EventStage"].push(filterName);
    this.state.hasFilter = true;
    this.state.paginationIds = [];
    this.state.lastId = null;
    this.state.searchValue = '';
    this.state.listOrder = 'Mais recentes';
    await this.startGettingExamsData({}, this.getQuery(this.state.filters));
    this.state.listEnd = this.hasExamList() ? this.state.exams.exams.length: 0;
    this.setState(this.state);
  }

  async changePage(direction) {
    let query = this.state.hasFilter ? 
      this.getQuery(this.state.filters) : 
      this.getQuerySearch(this.state.filtersSearch);

    if (direction == "previous" && this.state.listPage > 1) {
      if(this.hasExamList()){
        this.setState({
          listEnd: this.state.listEnd - this.state.exams.exams.length,
        });
      } 
      if (this.state.paginationIds.length <= 2) {
        this.setState({ paginationIds: [] });
        await this.startGettingExamsData(
          { orderDate: ORDER_DATE[this.state.listOrder] },
          query,
          this.state.listPage - 1,
          null
        );
      } else {
        await this.startGettingExamsData(
          {
            orderDate: ORDER_DATE[this.state.listOrder],
          },
          query,
          this.state.listPage - 1,
          this.state.paginationIds[this.state.paginationIds.length - 2]
        );
        let array = [...this.state.paginationIds];
        array.pop();
        this.setState({ paginationIds: array });
      }
      this.setState({
        listPage: this.state.listPage - 1,
      });
    } else if (
      direction == "next" &&
      this.state.listPage + 1 * 20 < this.state.exams.total
    ) {
      
      let result = await examsService.get({
        orderBy:   { orderDate: ORDER_DATE[this.state.listOrder] },
        filterBy: query,
        limit: 20,
        page:  this.state.listPage + 1,
        lastId: this.state.exams.lastId
      });

      if(!result || result.length === 0) return;
      
      this.state.paginationIds.push(this.state.exams.lastId);

      await this.startGettingExamsData(
        { orderDate: ORDER_DATE[this.state.listOrder] },
        query,
        this.state.listPage + 1,
        this.state.exams.lastId
      );
      if(this.hasExamList()){
        this.setState({
          listPage: this.state.listPage + 1,
          listEnd: this.state.listEnd + this.state.exams.exams.length,
        });
      }
      
    } else {
      console.error("ERRO");
    }
  }

  toggleLabel(ctrl) {
    if (ctrl === 0) {
      document.querySelector(".label-inside").classList.add("filled");
    } else if (
      ctrl === 1 &&
      document.getElementById("inputSearch").value === ""
    ) {
      document
        .querySelector(".label-inside")
        .classList.remove("filled");
    }
  }

  getQuery(filters) {
    let query = [];
    for (const filterIndex in filters) {
      if (Object.hasOwnProperty.call(filters, filterIndex)) {
        const filter = filters[filterIndex];
        if (filterIndex.includes("Date")) {
          if(filters[filterIndex]?.begin){
            query.push({
              'EstimatedResultDateBegin': moment(filters[filterIndex].begin, "DD/MM/YY").format(
                "YYYY-MM-DD"
              ),
            });
          }
          if(filters[filterIndex]?.end){
            query.push({
              'EstimatedResultDateEnd': moment(filters[filterIndex].end, "DD/MM/YY").format(
                "YYYY-MM-DD"
              ),
            });
          }
        } else {
          if (filters[filterIndex] instanceof Array) {
            if (filters[filterIndex].length != 0) {
              if (filterIndex === "Exam") {
                let value = filter.map((exam) => exam.split(":")[0].trim());
                query.push({ [filterIndex]: value });
              } else {
                query.push({ [filterIndex]: filter });
              }
            }
          } else {
            query.push({ [filterIndex]: filter });
          }
        }
      }
    }
    return query;
  }

  getQuerySearch(filters) {
    let value = this.inputSearchRef.current
      ? this.inputSearchRef.current.value
      : this.state.searchValue;
    let query = [];
    let userType = userService.getUserType();

    for (const filterIndex in filters) {
      if (Object.hasOwnProperty.call(filters, filterIndex)) {
        const filter = filters[filterIndex];
          if (filters[filterIndex] instanceof Array) {
            if (filters[filterIndex].length != 0) {
              query.push({ [filterIndex]: filter });
            }
          } else {
            query.push({ [filterIndex]: filter });
          }
      }
    }

    if (value !== "") {
      if (value.length === 10 && !isNaN(value)) {
        query.push({ OrderId: value });
      } else {
        if (userType === "PSC") {
          query.push({ ExamDescription: [value] })
        } else {
          query.push({ PatientName: value });
          query.push({ ExamDescription: [value] });
        }
      }
    }

    return query;
  }

  showDialogErrorMessage(title, errorMessage) {
    if (title && errorMessage) {
      let dialog = {
        type: "Error",
        title: title,
        message: errorMessage,
        show: true,
        confirmation: () => {
          this.setState({ dialog: { show: false } });
        },
      };
      sendEvent("show-dialog", dialog);
    }
  }

  async applyFilters(filters, hasFilter) {
    this.state.renderFilterScreen = false;
    this.state.paginationIds = [];
    this.state.lastId = null;
    this.state.hasFilter = hasFilter;
    this.state.filters = filters;
    this.state.listOrder = "Mais recentes";
    this.state.searchValue = "";

    if(!hasFilter){
      this.setState(this.state);
      this.clearAllFilters();
      this.props.updateFilterScreenStatus(false);
      return;
    }

    if (userService.getUserType() === "L2L" && !hasFilter) {
      this.stopGettingData();
      this.updateExams(null);
    } else {
      await this.startGettingExamsData({}, this.getQuery(filters));
    }

    this.state.listEnd = this.hasExamList() ? this.state.exams.exams.length : 0;
    this.props.updateFilterScreenStatus(false);
    this.setState(this.state);
  }

  closeFilters() {
    this.setState({ renderFilterScreen: false });
    this.props.updateFilterScreenStatus(false);
  }
  mountDateFilter(){
    if(this.state.filters['EstimatedResultDate']?.begin && this.state.filters['EstimatedResultDate']?.end){
      return `De ${this.state.filters['EstimatedResultDate']['begin']} Até ${this.state.filters['EstimatedResultDate']['end']}`;
    }
    return false;
  }

  mapFilters(array, filtersExt) {
    const FILTERS_COMPLETE ={
      'OrderId': 'Pedido: ',
      'EstimatedResultDateBegin': 'De: ',
     'EstimatedResultDateEnd': 'Até: ',
     'ProductionUnitName': "Unidade: "
    }

    const URGENCY={
      'Urgency': 'Urgentes'
    }

    let filters=[];
    array.forEach(element => {
      if(filtersExt[element] != null){
        if(filtersExt[element] instanceof Array){
          filtersExt[element].forEach(value=>{
            filters.push(
              <div className="label-tag">
                {STAGE_SHORT[value] || value}
                <div
                  className="remove-label-tag"
                  onClick={()=>{this.clearFilter(element, value)}}>
                  x
                </div>
              </div>
            );
          })
        }
        else if(element !== 'EstimatedResultDate'){
          filters.push(
            <div className="label-tag">
            { 
              filtersExt[element] && FILTERS_COMPLETE[element] &&
                 PRODUCTION_UNIT_ALIAS[filtersExt[element]] ?
                 FILTERS_COMPLETE[element] + PRODUCTION_UNIT_ALIAS[filtersExt[element]] :           
                  FILTERS_COMPLETE[element]
                    ? FILTERS_COMPLETE[element] + filtersExt[element]
                    : URGENCY[element] || filtersExt[element]
            }
              <div
                className="remove-label-tag"
                onClick={()=>{this.clearFilter(element)}}>
                x
              </div>
            </div>
          );
        }else{
          let labelDataFilter = this.mountDateFilter();
          if(labelDataFilter){
            filters.push(
              <div className="label-tag">
                {labelDataFilter}
                <div className="remove-label-tag"
                onClick={()=>  this.clearFilter(element)}
                >x</div>
              </div>
            )
          }
        }
      }

    });
    return filters;
  }
  
  clearSearch(){
    this.state.searchValue = '';
    this.state.filtersSearch = {};
    this.state.hasFilterSearch = false;
    this.setState(this.state, this.updateSearch);
  }

  async clearFilter(element, value = null) {
    const filterType = this.state.hasFilter ? 'filters' : 'filtersSearch';
    if (value) {
      let array = this.state[filterType][element];
      let index = array.indexOf(value);
      array.splice(index, 1);
      if (array.length > 0) {
        this.state[filterType][element] = array;
      } else {
        delete this.state[filterType][element];
      }
    } else {
      let filters = this.state[filterType];
      delete filters[element];
      this.state[filterType] = filters;
    }
    this.state.paginationIds = [];
    this.state.lastId = null;
    
    this.state.hasFilter = this.checkFilters('filters');
    this.state.hasFilterSearch = this.checkFilters('filtersSearch');
    this.state.listOrder = 'Mais recentes';
    
    if(!this.state.hasFilter){
      this.state.listPage = 1;
    }
    this.setState(this.state);
    
    if (!this.state.hasFilterSearch && !this.state.hasFilter && userService.getUserType() === "L2L") {
      if(this.state.searchValue === ''){
        this.stopGettingData();
        this.updateExams(null);
      }else{
        this.updateSearch();
      }
    } else {
      await this.startGettingExamsData(
        {},
        this.state.hasFilter ? this.getQuery(this.state.filters) : this.getQuerySearch(this.state.filtersSearch)
      );
    }
    this.updateListEnd();
  }

  checkFilters(filterType) {
    let hasFilter = false;
    for (let c = 0; c < searchIndex.length; c++) {
      hasFilter =
        (this.state[filterType][searchIndex[c]] != null &&
          !(this.state[filterType][searchIndex[c]] instanceof Array)) ||
        (this.state[filterType][searchIndex[c]] instanceof Array &&
          this.state[filterType][searchIndex[c]].length > 0) && filterType !== 'filtersSearch';

      if (hasFilter) {
        c = searchIndex.length[filterType]}
    }
    return hasFilter;
  }

  getExamHistory(exam) {
    this.setState({ renderHistory: true, examHistory: exam });
  }

  backListExam() {
    this.setState({ renderHistory: false });
    sendEvent("draw-history", null);
    if(window.innerWidth <= 820){
      addPaddingInMap({left: 0});
    }else{
      addPaddingInMap({left: 35});
    }
    setTimeout(function(){
      global.zapt && global.zapt.map && global.zapt.map.invalidateSize()
    });
  }

  handleChangeInputSearch(){
    this.setState({
      searchValue: this.inputSearchRef.current.value
    },this.updateSearch)
  }

  async updateSearch(orderBy = "orderDate", order = "ASC") {
    let value = this.inputSearchRef.current
      ? this.inputSearchRef.current.value
      : this.state.searchValue;

    let userType = userService.getUserType();
    if (value === "") {
      this.state.hasFilterSearch = false;
      this.state.filtersSearch = {};
      this.state.listOrder = "Mais recentes";
      this.setState(this.state);
      if (userType === "L2L" && !this.state.hasFilter) {
        this.stopGettingData();
        this.updateExams(null);
      } else {
        await this.startGettingExamsData(
          { [orderBy]: order },
          this.getQuery(this.state.filters)
        );
      }
    } else if (value.length === 10 && !isNaN(value)) {
      await this.startGettingExamsData({ [orderBy]: order }, [
        { OrderId: value },
      ]);
    } else if(isAlphanumericOrderId(value)){

      let orderId = await examsService.getOrderIdFromAlphanumericCode(value);

      orderId && await this.startGettingExamsData({ [orderBy]: order }, [
        { OrderId: orderId },
      ]);
    } else{    
      if (userType === "PSC") {
        await this.startGettingExamsData({ [orderBy]: order }, [
          { ExamDescription: [value] },
        ]);
      } else {
        await this.startGettingExamsData({ [orderBy]: order }, [
          { PatientName: value },
          { ExamDescription: [value] },
        ]);
      }
    }

    this.updateListEnd()
  }

  hasExamList(){
    if(this.state.exams && this.state.exams.exams && this.state.exams.exams.length){
      return true
    }
    return false;
  }

  updateListEnd(){
    if(this.hasExamList()){
      this.setState({
        listEnd: this.state.exams.exams.length
      })
    }
  }

  render() {
    const btDefaultStyle = {
      marginTop: "5px",
      marginBottom: "5px",
    };

    const showExams =
      userService.getUserType() === "PSC" || this.state.hasFilter;

    return this.state.loading ? (
      <LoadDNA loading={true} width="150px" height="150px" />
    ) : (
      <>
        {!this.state.renderFilterScreen ? (
          this.state.renderHistory ? (
            <History
              exam={this.state.examHistory}
              backListExam={this.backListExam.bind(this)}
            />
          ) : (
            <>
              <div className="lab-container-title mb-5">
                <h3 className="lab-title">Exames por situação </h3>
                <div className="exams-total-qty">
                  Total
                  <span className="exams-qty">
                    {this.state.hasFilter || this.state.hasFilterSearch
                      ? !this.state.exams
                        ? 0
                        : this.state.exams.total
                        ? this.state.exams.total
                        : 0
                      : this.props.status && this.props.status
                      ? this.props.status.TOTAL
                      : 0}
                  </span>
                </div>
              </div>
              <div className="breadcrumbRow mb-30">
                <span className="breadcrumbItem">Brasil</span>
                <span className="breadcrumbItem">
                  {this.props.currentProductionUnit === "HP"
                    ? "Todas as unidades"
                    : PRODUCTION_UNIT_ALIAS[this.props.currentProductionUnit]}
                </span>
              </div>
              {this.props.status &&
              this.props.status != null &&
              !this.state.hasFilter &&
              !this.state.hasFilterSearch ? (
                <>
                  <Status
                    status={this.props.status}
                    filterBy={this.addStatusFilter.bind(this)}
                  />
                </>
              ) : (
                <>
                  <div
                    className="row align-items-center row-gutter-20 mb-10"
                    style={{ marginBottom: "6px" }}
                  >
                    <div className="col">
                      {this.state.hasFilter ? (
                        <span
                          className="bt-default bt-filter"
                          onClick={() => {
                            this.setState({ renderFilterScreen: true });
                            this.props.updateFilterScreenStatus(true);
                          }}
                        >
                          Busca
                        </span>
                      ) : null}
                    </div>
                    <div className="col-auto">
                      <div
                        className="filter-clear"
                        onClick={() => {
                          this.clearAllFilters();
                        }}
                      >
                        Limpar filtros
                      </div>
                    </div>
                  </div>
                  <div className="label-container mt-0 mb-10">
                    {this.state.searchValue !== ""
                      ? this.mapFilters(searchIndex, this.state.filtersSearch)
                      : this.mapFilters(searchIndex, this.state.filters)}
                  </div>
                </>
              )}
              {!this.state.hasFilter || this.state.hasFilterSearch ? (
                <>
                  <div className="form-search">
                    <div
                      className={`form-group label-inside form-group-ico-right ${
                        this.state.searchValue !== "" ? "filled" : "ico-search"
                      }`}
                    >
                      {this.state.searchValue !== "" ? (
                        <span
                          className="ico-clear-search"
                          onClick={() => this.clearSearch()}
                        ></span>
                      ) : null}
                      <label htmlFor="inputSearch" className={`form-label`}>
                        {userService.getUserType() !== "L2L"
                          ? "Busque por pedido ou exame"
                          : "Busque por pedido, exame ou paciente"}
                      </label>
                      <input
                        autoComplete="off"
                        value={this.state.searchValue}
                        ref={this.inputSearchRef}
                        type="text"
                        className="form-control"
                        id="inputSearch"
                        onChange={() => {
                          this.handleChangeInputSearch();
                        }}
                        onFocus={() => {
                          this.toggleLabel(0);
                        }}
                        onBlur={() => {
                          this.toggleLabel(1);
                        }}
                      />
                    </div>
                  </div>
                </>
              ) : null}
              <div
                className="row align-items-center row-gutter-10 mb-10"
                style={{ marginLeft: "-5px", marginRight: "-5px" }}
              >
                {this.state.searchValue === "" && !this.state.hasFilter ? (
                  <div className="row-sm-auto">
                    <div
                      style={{
                        color: "#3167ff",
                        cursor: "pointer",
                        marginLeft: "4px",
                      }}
                      onClick={() => {
                        this.setState({ renderFilterScreen: true });
                        this.props.updateFilterScreenStatus(true);
                      }}
                    >
                      Busca Avançada
                    </div>
                  </div>
                ) : null}
                {showExams || this.state.hasFilter || this.state.searchValue !== "" ? (
                  <>
                    <span
                      style={{ fontSize: 11, marginBottom: 5, marginTop: 5 }}
                    >
                      <b>
                        {
                          "* Exames liberados há mais de 15 dias podem não estar disponíveis."
                        }
                      </b>
                    </span>
                    <span style={{ fontSize: 11, marginBottom: 5 }}>
                      <b>
                        {"* Contate o Customer Service em caso de dúvidas. "}
                      </b>
                    </span>
                  </>
                ) : null}
                {this.state.exams && this.state.exams.exams ? (
                  <>
                    <div className="col">
                      <span className="showing-results">
                        Exibindo{" "}
                        {this.state.listEnd - this.state.exams.exams.length + 1}{" "}
                        a {this.state.listEnd} de {this.state.exams.total || 0}
                      </span>
                    </div>
                    <div className="col-auto">
                      <div className="dropdown" id="dropdown-filter">
                        <div
                          className="bt-default bt-filter-order"
                          role="button"
                          id="orderExams"
                          data-target="dropdown-filter"
                          aria-expanded="false"
                          style={btDefaultStyle}
                          onClick={() => {
                            this.openDropDown();
                          }}
                        >
                          {this.state.listOrder}
                        </div>
                        <ul
                          id="dropdown-menu-filter"
                          className="dropdown-menu dropdown-menu-end dropdown-menu-default"
                          aria-labelledby="orderExams"
                        >
                          <li>
                            <div
                              id="recentes"
                              className={`dropdown-item ${
                                this.state.listOrder === "Mais recentes"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => {
                                this.closeDropDown();
                                this.toggleOrderby("recentes");
                              }}
                            >
                              Mais recentes
                            </div>
                          </li>
                          <li>
                            <div
                              id="antigos"
                              className={`dropdown-item ${
                                this.state.listOrder === "Mais antigos"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => {
                                this.closeDropDown();
                                this.toggleOrderby("antigos");
                              }}
                            >
                              Mais antigos
                            </div>
                          </li>
                          <li>
                            <div
                              id="urgentes"
                              className={`dropdown-item ${
                                this.state.listOrder === "Mais urgentes"
                                  ? "active"
                                  : ""
                              }`}
                              onClick={() => {
                                this.closeDropDown();
                                this.toggleOrderby("urgentes");
                              }}
                            >
                              Mais urgentes
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>
              {this.state.loadingExams ? (
                <LoadDNA loading={true} width="150px" height="150px" />
              ) : null}
              {!this.state.loadingExams &&
              this.state.exams &&
              this.state.exams.exams ? (
                <>
                  <List
                    exams={this.state.exams.exams}
                    getExamHistory={this.getExamHistory.bind(this)}
                  />
                  <div className="row align-items-center mt-10">
                    <div className="col">
                      <span className="showing-results">
                        Exibindo{" "}
                        {this.state.listEnd - this.state.exams.exams.length + 1}{" "}
                        a {this.state.listEnd} de {this.state.exams.total || 0}
                      </span>
                    </div>
                    <div className="col-auto">
                      <div
                        style={
                          this.state.listPage === 1
                            ? { visibility: "hidden" }
                            : { visibility: "visible" }
                        }
                        className="bt-default bt-load-less-20"
                        onClick={() => {
                          this.changePage("previous");
                        }}
                      ></div>
                      <div
                        style={
                          this.state.exams.total <= 20 ||
                          this.state.listPage * 20 >= this.state.exams.total
                            ? { visibility: "hidden" }
                            : { visibility: "visible" }
                        }
                        className="bt-default bt-load-plus-20"
                        onClick={() => {
                          this.changePage("next");
                        }}
                      ></div>
                    </div>
                  </div>
                </>
              ) : (
                <div style={{marginTop: 10}}>
                  {!this.state.loadingExams ? (
                    Object.keys(this.state.filters).length != 0 ? (
                      Object.keys(this.state.filters).length > 1 ? (
                        !this.state.exams || this.state.exams.length === 0 ? (
                          <p>
                            Não foram encontrados exames para os filtros
                            selecionados.
                          </p>
                        ) : null
                      ) : !this.state.exams || this.state.exams.length === 0 ? (
                        <p>
                          Não foram encontrados exames para o filtro
                          selecionado.
                        </p>
                      ) : null
                    ) : showExams || this.state.searchValue !== "" ? (
                      <p>Nenhum exame foi encontrado.</p>
                    ) : null
                  ) : null}
                </div>
              )}
            </>
          )
        ) : (
          <Filters
            filters={this.state.filters}
            hasFilter={this.state.hasFilter}
            exams={ExamsService.getTypes}
            close={this.closeFilters.bind(this)}
            submit={this.applyFilters.bind(this)}
          />
        )}
      </>
    );
  }
}

export default withRouter(Exams);
